/**
 * @generated SignedSource<<1c37f92912100a40c37045bf2730482c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef$data = {
  readonly isAiEnabledInAdminHub?: boolean | null | undefined;
  readonly isVirtualAgentAvailable: boolean | null | undefined;
  readonly " $fragmentType": "actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef";
};
export type actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef$key = {
  readonly " $data"?: actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "checkForAiEnabledFF"
    }
  ],
  "kind": "Fragment",
  "name": "actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isVirtualAgentAvailable"
    },
    {
      "condition": "checkForAiEnabledFF",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAiEnabledInAdminHub"
        }
      ]
    }
  ],
  "type": "VirtualAgentFeatures"
};

(node as any).hash = "48a1fb969d403dc92a7ec64492b0c2a3";

export default node;
